import AirtableTable from "../AirtableTable";
import { Booking } from "../models";
import { airtableFormulas } from "../formulas";

export const bookingsTableId = "tbl1SOEuYHNn4C4Mb";

export const bookingFieldIds = {
  bookingId: "fld8FtRXcNVZMHoqv",
  educator: "fldkhClkZgwTmginN",
  educatorEmailAddress: "fldESc7u0coJ40s9A",
  proposedDate1: "fldRCmdFB78gYBlmL",
  proposedDate2: "fldsLwOMtFfyiQyuZ",
  proposedDate3: "fldmdFYlAUJIAfnco",
  date1Notes: "fldkCZrhkZIW2KLIn",
  date2Notes: "fldHI2qPT8YH16GqM",
  date3Notes: "fldzZ6wuwqbnZ4vHP",
  status: "fldD3AKuUmZuijRw8",
  confirmedDateTime: "fldTyi0PG1zIt5ybb",
  roundNumber: "fld0EJnW3xuiCWhBk"
};

export const bookingFieldNames = {
  bookingId: "Booking ID",
  educator: "Educator",
  educatorEmailAddress: "Educator E-mail Address",
  artistEmailAddress: "Artist E-mail Address",
  proposedDate1: "Proposed Date 1",
  proposedDate2: "Proposed Date 2",
  proposedDate3: "Proposed Date 3",
  date1Notes: "Date 1 Notes",
  date2Notes: "Date 2 Notes",
  date3Notes: "Date 3 Notes",
  status: "Status",
  confirmedDateTime: "Confirmed Date & Time",
  roundNumber: "Round Number"
};

export class BookingsTable extends AirtableTable<Booking> {
  constructor(instance: any) {
    super(instance, bookingsTableId);
    this.returnFieldsByFieldId = false;

    this.fields = [
      bookingFieldIds.bookingId,
      bookingFieldIds.educator,
      bookingFieldIds.educatorEmailAddress,
      bookingFieldIds.proposedDate1,
      bookingFieldIds.proposedDate2,
      bookingFieldIds.proposedDate3,
      bookingFieldIds.date1Notes,
      bookingFieldIds.date2Notes,
      bookingFieldIds.date3Notes,
      bookingFieldIds.status,
      bookingFieldIds.confirmedDateTime,
      bookingFieldIds.roundNumber
    ];
  }

  getBookingByEducatorEmail = async (email: string) => {
    const bookings = await this.list({
      filterByFormula: airtableFormulas.bookings.byEducatorEmail(email)
    });

    if (!bookings?.length) return null;

    return bookings[0];
  }

  getBookingByArtistEmail = async (email: string) => {
    const normalizedEmail = email.trim().toLowerCase();
    if (!normalizedEmail) return null;

    const bookings = await this.list({}, undefined, true);
    const artistEmailFieldCandidates = [
      "Artist E-mail Address",
      "Artist Email Address",
      "Artist Email"
    ];

    const matchingBooking = bookings.find((booking: any) => {
      const candidateValues = [
        ...artistEmailFieldCandidates.map(fieldName => booking?.[fieldName]),
        booking?.[bookingFieldNames.artistEmailAddress]
      ];

      return candidateValues.some(candidate => {
        const candidateValue = Array.isArray(candidate) ? candidate[0] : candidate;
        return typeof candidateValue === "string" && candidateValue.trim().toLowerCase() === normalizedEmail;
      });
    });

    return matchingBooking || null;
  }
}
